import React from 'react';

import autoBind from 'react-autobind';
import Switch, { Case } from 'react-switch-case';

// import other components within the same project here

import Localization from "../../Localization.jsx"

import RetrieverPage from "../../pages/RetrieverPage.jsx"

import {
  Icon,
  Button,
} from '@material-ui/core';

class RetrieverBar extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
    };
    autoBind(this);
  }

  render() {
    return (
      <div ref="div" style={{padding:"10px 0 10px 10px"}}>
        <Switch condition={this.props.parent.state.status}>
          <Case value={RetrieverPage.RET_VIEW_DATES()}>
            <Button
              color="secondary"
              onClick={this.props.root.goBackHistory}
            >
              <Icon className="buttonIconLeft">arrow_back</Icon>
              {Localization.strings.BACK}
            </Button>
            <Button
              color="primary"
              onClick={this.props.parent.exportAnswer}
            >
              <Icon className="buttonIconLeft">save_alt</Icon>
              {Localization.strings.EXPORT_ANSWER}
            </Button>
          </Case>
          <Case value={RetrieverPage.RET_VIEW_SUBMISSION_GROUPS()}>
            <Button
              color="secondary"
              onClick={this.props.root.goBackHistory}
            >
              <Icon className="buttonIconLeft">arrow_back</Icon>
              {Localization.strings.SUBMISSION_DATE}
            </Button>
          </Case>
          <Case value={RetrieverPage.RET_VIEW_SUBMISSION_HISTORY()}>
            history
          </Case>
        </Switch>
      </div>
    )
  }
}

export default RetrieverBar;
